<script setup>
import { useModal } from 'vue-final-modal';
import HawkFieldsSelector from '~/common/components/organisms/hawk-fields-selector/hawk-fields-selector.vue';
import { useCommonStore } from '~/common/stores/common.store.js';
import { useDashboardStore } from '~/dashboard/store/dashboard.store.js';
import { useDashboardAssetsStore } from '~/dashboard/store/dashboard-assets-store.js';

const dashboard_store = useDashboardStore();

const common_store = useCommonStore();

const dashboard_assets_store = useDashboardAssetsStore();

const assets_configuration = computed(() => dashboard_assets_store.assets_configuration);

const column_options = computed(() => {
  const custom_field_columns = common_store?.assets_custom_fields?.map(item => ({
    id: item.uid,
    accessorKey: item.uid,
    header: item.name,
  })) || [];
  return [
    { id: 'name', accessorKey: 'name', header: 'Asset Name', static: true },
    { id: 'code', accessorKey: 'code', header: 'Asset code', static: true },
    { id: 'address', accessorKey: 'address', header: 'Address', static: true },
    ...custom_field_columns,
  ];
});

function handleColumnsConfiguration() {
  const configure_columns_popup = useModal({
    component: HawkFieldsSelector,
    attrs: {
      min_selected_items: 1,
      items: column_options.value,
      selected_items: assets_configuration.value.columns,
      label_key: 'header',
      value_key: 'id',
      onClose() {
        configure_columns_popup.close();
      },
      texts: {
        heading: 'Customize columns',
        left_heading: 'Hidden Columns',
        right_heading: 'Visible Columns',
      },
      has_field_pin_option: true,
      close_on_save: true,
      update: (columns) => {
        dashboard_assets_store.update_assets_configuration({ ...dashboard_assets_store.assets_configuration, columns });
        dashboard_store.set_widget_configuration({
          ...assets_configuration.value,
        });
      },
    },
  });
  configure_columns_popup.open();
}
</script>

<template>
  <div>
    <div v-for="col in assets_configuration?.columns" :key="col.key" class="flex items-center mb-2 px-2 h-[36px] border border-gray-300 rounded-lg">
      {{ col.header }}
    </div>

    <hawk-button
      type="outlined"
      size="xs"
      @click="handleColumnsConfiguration"
    >
      {{ $t('Choose columns') }}
    </hawk-button>
  </div>
</template>
